module.exports = __webpack_public_path__ + "img/Deirdre_Breakenridge.jpeg";